module.exports = __webpack_public_path__ + "static/media/404error.e491cc01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/404error.svg
// module id = 426
// module chunks = 0